<template>
  <!-- <v-card flat :color="$vuetify.theme.dark ? '#2d2d2d' : '#f9fafb'">
    <v-row class="pa-5">
      <v-col cols="1"></v-col>
      <v-col cols="10"> -->
        <v-card class="pa-5 pt-0" >
          <PortfolioCard />
          <v-card class="pa-5 mt-5" :color="$vuetify.theme.dark ? '#2d2d2d' : '#f9fafb'">
            <v-tabs v-model="activeTab" background-color="transparent" class="mx-5">
              <v-tab v-for="tab in tabs" :key="tab.name" :value="tab.name">
                <v-icon class="me-2">{{ tab.icon }}</v-icon>
                {{ $t(tab.name + ".title") }}
              </v-tab>
            </v-tabs>
            <v-divider class="my-2"></v-divider>
            <component
              :studentGuid="studentId"
              v-if="currentComponent"
              :is="currentComponent"
            ></component>
          </v-card>
        </v-card>
      <!-- </v-col>
      <v-col cols="1"></v-col> </v-row
  ></v-card>  -->
</template>

<script>
import PortfolioCard from "../../../components/portfolio/portfolioCard.vue";
import Achievements from "./achievements.vue";
import Goals from "./goals.vue";
import Worksamples from "./worksamples.vue";

export default {
  name: "Portfolio",
  components: {
    PortfolioCard,
    Worksamples,
    Achievements,
    Goals
  },
  data() {
    return {
      activeTab: "portfolio.WorkSample", // <-- make it a string, matching the route
      tabs: [
        {
          name: "portfolio.WorkSample",
          routeName: "portfolio.WorkSample",
          hash: "worksamples",
          icon: "mdi-file-document"
        },
        {
          name: "portfolio.Achievement",
          routeName: "portfolio.Achievements",
          hash: "achievements",
          icon: "mdi-trophy"
        },
        {
          name: "portfolio.Goals",
          routeName: "portfolio.Goals",
          hash: "goals",
          icon: "mdi-bullseye"
        }
      ]
    };
  },
  watch: {
    activeTab(newVal) {
      const currentTab = this.$route.query.tab;
      const newTab = this.tabs[newVal].hash;
      if (currentTab !== newTab) {
        this.$router.replace({ query: { tab: newTab } });
      }
    }
  },
  created() {
    const { tab } = this.$route.query;
    if (tab) {
      const index = this.tabs.findIndex(t => t.hash === tab);
      if (index !== -1) {
        this.activeTab = index;
      }
    }
  },
  computed: {
    studentId() {
      return this.$route.params.id;
    },
    currentComponent() {
      const map = {
        0: "Worksamples",
        1: "Achievements",
        2: "Goals"
      };
      return map[this.activeTab] || null;
    }
  }
};
</script>
